<template>
  <div class="phone-summary">
    <div
      class="d-flex flex-wrap"
      style="gap: 4px 16px"
    >
      <span v-if="data.number"><strong>{{ $t('involvedSummary.phone.numberLabel') }}</strong> {{ data.number }}</span>
      <span v-if="data.imei"><strong>{{ $t('involvedSummary.phone.imeiLabel') }}</strong> {{ data.imei }}</span>
      <span v-if="data.carrier"><strong>{{ $t('involvedSummary.phone.carrierLabel') }}</strong> {{ data.carrier }}</span>
      <span v-if="data.owner_name"><strong>{{ $t('involvedSummary.phone.ownerLabel') }}</strong> {{ data.owner_name }}</span>
    </div>
    <div
      v-if="data.observation"
      class="text-muted small mt-1"
    >
      {{ data.observation }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneSummary',
  props: {
    data: { type: Object, default: () => ({}) },
  },
}
</script>
